import * as React from 'react';
import styles from './index.module.sass'
import { SIMULATION_SELECT } from 'constants/commonContsnts';
import Slider from 'components/Slider';
import { animate } from 'lib/animation';
import { OPEN, CLOSE } from 'constants/animationConstants';
import Viewer from 'components/Scene/viewer';
import { Simulation } from 'types/data';


interface SimulationSelectProps {
  simulations: Simulation[],
  viewerApi: Viewer,
  setActiveSimulation: Function,
  setSimulationSelect: Function,
  simActive: Boolean,
  lastActiveSimulation?: Simulation
}

interface OnSelect {
  content: Simulation,
  animationItems: any,
}

const SimulationSelect: React.FunctionComponent<SimulationSelectProps> = ({ 
    simActive, 
    setActiveSimulation, 
    simulations, 
    viewerApi, 
    setSimulationSelect,
    lastActiveSimulation
  }) => {
    
  const root = React.useRef(null)
  const [loading, ] = React.useState({
    progress: 0,
    max: 1
  })

  const items = simulations!.map(item => ({
    images: item.images!,
    title: item.title,
    subTitle: item.subTitle,
    item
  }))

  let selectClicked = false
  let backClicked = false 

  
  const onSelect = async(props: OnSelect) => {
    const { content, animationItems } = props

    if(!selectClicked && !backClicked && animationItems) {

      // await animate(animationItems, CLOSE_WITH_LOADER)
      
      // await viewerApi.initSimLoading()
      
      // await animate(animationItems, CLOSE_LOADED)
      selectClicked = true
      
      await animate(animationItems, CLOSE)
      viewerApi.blurNode(false)
      
      setSimulationSelect(false)
      setActiveSimulation(content)
    }
  }

  const onOpen = async (animationItems: any) => {
    animate(animationItems, OPEN)
  }

  const onBack = async (animationItems: any) => {
    if(!backClicked && !selectClicked) {

      backClicked = true
      await animate(animationItems, CLOSE)
      
      viewerApi.blurNode()
      
      viewerApi.startLandingAudio()
      
      viewerApi.isSimulation = false
      
      viewerApi.goToBasePosition()
      
      setActiveSimulation(undefined)
      setSimulationSelect(false)
    }

  }

  return (
    <div className={styles.root} ref={root}>
      <div className={styles.wrapper}>
        <Slider 
          items={items} 
          startItem={lastActiveSimulation ? simulations.indexOf(lastActiveSimulation) : 0}
          onMount={() => {}}
          loading={loading} 
          onSelect={onSelect} 
          type={SIMULATION_SELECT} 
          onOpen={onOpen} 
          onBack={onBack}
        />
      </div>
    </div>
  );
};

export default SimulationSelect;
